// Local replacement for react-gtm-module: that library creates its inline
// <script> tags via document.createElement + innerHTML without ever setting
// a `nonce`, and CSP script-src no longer allows 'unsafe-inline' (index.js).
// A nonce must be set on the element *before* it's inserted into the DOM —
// inline scripts inserted via insertBefore/appendChild execute synchronously
// at insertion time, so patching it in afterwards (e.g. via MutationObserver)
// would be too late.

function createNoncedScript(content) {
  const script = document.createElement('script');
  script.nonce = window.__webpack_nonce__;
  script.innerHTML = content;
  return script;
}

export function initializeGtm(gtmId) {
  const bootstrapScript = `
    (function(w,d,s,l,i){w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');`;

  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

  document.head.insertBefore(createNoncedScript(bootstrapScript), document.head.childNodes[0]);
  document.body.insertBefore(noscript, document.body.childNodes[0]);
}

export function pushGtmDataLayer(data, dataLayerName = 'dataLayer') {
  if (window[dataLayerName]) {
    window[dataLayerName].push(data);
    return;
  }
  // Defensive fallback — unreachable in this app today, since initializeGtm()
  // always runs before ReactDOM.render and already sets up window.dataLayer
  // synchronously. Kept so a future reordering degrades gracefully instead of
  // throwing, still respecting the CSP nonce.
  const script = createNoncedScript(
    `window.${dataLayerName} = window.${dataLayerName} || []; window.${dataLayerName}.push(${JSON.stringify(
      data,
    )});`,
  );
  document.head.insertBefore(script, document.head.childNodes[0]);
}
